import { render, staticRenderFns } from "./ManagingResultReport.vue?vue&type=template&id=27a0744d&scoped=true&"
import script from "./ManagingResultReport.vue?vue&type=script&lang=js&"
export * from "./ManagingResultReport.vue?vue&type=script&lang=js&"
import style0 from "./ManagingResultReport.vue?vue&type=style&index=0&id=27a0744d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0744d",
  null
  
)

export default component.exports